import React from "react"
import { NavDocumentSearchField, NavFaultSearchField, NavServiceLogSearchField } from "./NavSearch";
import NavBarSectionSelect from "./NavBarSectionSelect";
import { Box } from "@mui/material";
import useLiteratureCurrentView from "../hooks/useLiteratureCurrentView";
import NavEngineInfo from "./NavEngineInfo";

export default function NavCenterSection() {
    const { isInDocumentListView, isInDocumentView, isInFaultList, isInEngineInfo, isInServiceLogList } = useLiteratureCurrentView();

    if (!isInDocumentListView && !isInDocumentView && !isInFaultList && !isInEngineInfo && !isInServiceLogList) {
        return null;
    }

    return (
        <>
            <NavDocumentSearchField />
            <NavFaultSearchField />
            <NavServiceLogSearchField />
            <NavBarSectionSelect />
            <NavEngineInfo />
            <Box sx={{ flexGrow: 1 }} />
        </>
    );
}